import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EnumHelper, ModalComponent } from 'mbs-ui-kit';
import { stopAfterMinutesValidator } from 'mbs-ui-shared@utils/validators';
import { OverdueAfterSuccessPeriod } from 'wizards/models/schedule-models';

@UntilDestroy()
@Component({
  selector: 'nbf-additional-modal-component',
  templateUrl: './additional-modal.component.html'
})
export class NBFAdditionalModalComponent implements OnInit {
  public form: UntypedFormGroup;
  public isRDMode = false;
  public readonly overduePeriod = EnumHelper.EnumToSelectIndexesArray(OverdueAfterSuccessPeriod);
  public readonly elementSelectors = {
    id: {
      startFromDate: 'NBF-Additional-start-from-date',
      stopAfterCheckbox: 'NBF-Additional-stop-after-checkbox',
      stopAfterHours: 'NBF-Additional-stop-after-hours',
      stopAfterMinutes: 'NBF-Additional-stop-after-minutes',
      alertOverdueBlock: 'NBF-Additional-overdue-block',
      alertOverdueCheckbox: 'NBF-Additional-overdue-checkbox',
      alertOverdueDays: 'NBF-Additional-overdue-days',
      alertOverduePeriod: 'NBF-Additional-overdue-period',
      forceMissedCheckbox: 'NBF-Additional-force-missed-checkbox',
      saveButton: 'NBF-Additional-Modal-save-button',
      cancelButton: 'NBF-Additional-Modal-cancel-button'
    }
  };

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  ngOnInit() {
    this.initForm();
    this.fullData();
  }

  saveClickHandler(): void {
    if (!this.form.valid) {
      return;
    }

    this.baseModal.save({ data: this.form.getRawValue() });
  }

  cancelClickHandler(): void {
    this.baseModal.close();
  }

  stopAfterEnabledChangeHandler(event): void {
    const action = event ? 'enable' : 'disable';

    ['stopAfterHours', 'stopAfterMinutes'].forEach((name) => {
      this.form.get(name)[action]();
    });

    if (event) this.form.get('stopAfterMinutes').markAllAsTouched();
  }

  stopAfterHoursChangeHandler(event): void {
    if (typeof event === 'number' && !isNaN(event)) this.form.get('stopAfterMinutes').updateValueAndValidity();
  }

  // TODO: Test
  overdueAfterSuccessChangeHandler(event): void {
    const action = event ? 'enable' : 'disable';

    ['overdueAfterSuccessAmount', 'overdueAfterSuccessPeriod'].forEach((name) => {
      this.form.get(name)[action]();
    });
  }

  private fullData(): void {
    const data = this.baseModal?.data;
    const isManualMode = data?.isManualMode;

    this.form.reset(data);
    this.isRDMode = data?.isRDMode;

    this.stopAfterEnabledChangeHandler(this.form.get('StopAfterEnabled').value);

    if (!this.isRDMode) {
      this.overdueAfterSuccessChangeHandler(this.form.get('overdueAfterSuccessEnabled').value);
    }

    if (isManualMode) {
      ['startFromDate', 'ForceMissedSchedule'].forEach((key) => this.form.get(key).disable());
    }
  }

  private initForm() {
    const data = this.baseModal?.data;
    const isRDMode = data?.isRDMode;
    const controls: Record<string, FormControl> = {
      startFromDate: new FormControl(new Date()),
      StopAfterEnabled: new FormControl(false),
      stopAfterHours: new FormControl(0),
      stopAfterMinutes: new FormControl(0),
      ForceMissedSchedule: new FormControl(false)
    };

    if (!isRDMode) {
      controls.overdueAfterSuccessEnabled = new FormControl(false);
      controls.overdueAfterSuccessAmount = new FormControl(1, Validators.min(1));
      controls.overdueAfterSuccessPeriod = new FormControl(0);
    }

    this.form = new UntypedFormGroup(controls);

    this.form.get('stopAfterMinutes').addValidators(stopAfterMinutesValidator.bind({ stepForm: this.form }, 'stopAfterHours'));
  }
}
